import { Heading } from "@postcheesy/ui-lib/atoms";
import React from "react";
import { Container } from "../components/layouts/container";
import { Header } from "../components/layouts/header";
import { Layout } from "../components/layouts/layout";

export const NotFoundPage: React.FC = () => {
  return (
    <>
      <Layout>
        <Container>
          <Heading className="text-4xl">Page Not Found</Heading>
          <Heading>404</Heading>
        </Container>
      </Layout>
    </>

  );
};
